var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unauthenticated"},[_c('h1',[_vm._v("UNAUTHENTICATED")]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.$router.push('/authenticate')}}},[_vm._v("Authenticate")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aa41479","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Unauthenticated.vue
// module id = null
// module chunks = 